import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchMinimumCartSystemFilterEntity } from '../../domain/entities/BranchMinimumCartSystemFilterEntity'

export class BranchMinimumCartSystemFilterModel extends BranchMinimumCartSystemFilterEntity {
  constructor(dataDto: BranchMinimumCartSystemFilterEntity) {
    super()
    mapEntityProperties<BranchMinimumCartSystemFilterModel>(this, dataDto)
  }
}
